import {TEST, WINDOW, logger} from 'tizra'

const log = logger('quickstart/utils/isomorphic-observer')

class NullObserver {
  observe() {}
  unobserve() {}
  disconnect() {}
}

export const isomorphicObserver = observerName => {
  if (!WINDOW) {
    return NullObserver
  }
  if (!WINDOW[observerName]) {
    if (!TEST) {
      log.warn(`window object missing ${observerName}`)
    }
    return NullObserver
  }
  return WINDOW[observerName]
}
